/**
 * © 2025 Little Shilling, Inc.
 * Shon Little
 * Created: 2025-08-05
 */

// Add third-party dependencies.
import { Container, Paper, Box } from '@mui/material';

// Add local dependencies.
import PasswordResetConfirmForm from './PasswordResetConfirmForm';

/**
 * Password reset confirmation page component.
 * @example
 * return <PasswordResetConfirm />
 * @returns {React.ReactElement} The password reset confirmation page component.
 */
const PasswordResetConfirm: React.FC = () => (
  <Container component="main" maxWidth="sm">
    <Box
      sx={{
        marginTop: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Paper elevation={3} sx={{ padding: 4, width: '100%' }}>
        <PasswordResetConfirmForm />
      </Paper>
    </Box>
  </Container>
);

export default PasswordResetConfirm;
